// Floating action menu (Plan 1 `ui.js` `TDS.menu`) opened next to a row/anchor button. Global
// singleton rendered once by MenuHost.vue.
import { reactive } from 'vue'

export interface MenuItem {
  label: string
  danger?: boolean
  fn?: () => void
}
export type MenuEntry = MenuItem | '-'

interface MenuState {
  visible: boolean
  x: number
  y: number
  items: MenuEntry[]
}

const state = reactive<MenuState>({ visible: false, x: 0, y: 0, items: [] })

export function useContextMenu() {
  function openMenu(anchor: HTMLElement, items: MenuEntry[]): void {
    const r = anchor.getBoundingClientRect()
    state.x = Math.max(8, r.right + window.scrollX - 180)
    state.y = r.bottom + window.scrollY + 2
    state.items = items
    state.visible = true
  }
  function closeMenu(): void {
    state.visible = false
  }
  return { state, openMenu, closeMenu }
}
